import { create } from "zustand";
import { getHealth } from "../api/client.js";

type Status = "unknown" | "ok" | "error";

interface ServerState {
  status: Status;
  simVersion: string | null;
  checkHealth: () => Promise<void>;
}

export const useServerStore = create<ServerState>((set) => ({
  status: "unknown",
  simVersion: null,
  checkHealth: async () => {
    try {
      const health = await getHealth();
      set({ status: "ok", simVersion: health.simVersion });
    } catch {
      set({ status: "error", simVersion: null });
    }
  },
}));
